import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import { setPatientId } from "@/store/patients/patients";
import { setIsVisibleModalDialog } from "@/store/ui/ui";
import { RootState } from "@/store/store";
import Navigation from "@/components/Navigation/Navigation";
import PatientsList from "@/components/PatientsList/PatientsList";
import PatientsHeader from "@/components/PatientsHeader/PatientsHeader";
import PatientsPagination from "@/components/PatientsPagination/PatientsPagination";
import useSearch from "@/hooks/useSearch";
import AppointmentsSearchDrayer from "@/components/AppointmentsComponents/AppointmentsSearchDrayer/AppointmentsSearchDrawer";
import ModalDialog from "@/components/ModalDialog/ModalDialog";
import useDeleteEntity from "@/hooks/useDeleteEntity";
import { deleteItemFromData } from "@/store/data/dataSlice";

import "@/shared/styles/layout.scss";
import "./Patientspage.scss";

export default function Patients() {
    const [query, setQuery] = useState<string>("");
    const [open, setOpen] = useState<boolean>(false);
    const { handleDelete } = useDeleteEntity();
    const dispatch = useDispatch();
    const data = useSelector((state: RootState) => state.data.data);
    const {
        isLoading,
        activepage,
        handleChangeActivepage,
        limitPage,
        handleChangeSortOpton,
        sortOption,
    } = useSearch("patients/searchpatient", query);

    const patientId = useSelector(
        (state: RootState) => state.patients.patientId,
    );
    let patientName = "";

    if (data && data.length > 0 && patientId) {
        const nameArr = data.filter(item => item._id === patientId);
        if (nameArr.length > 0) {
            patientName = nameArr[0].name;
        }
    }

    function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
        setQuery(e.target.value);
    }

    function toggleDrawer(isOpen: boolean): void {
        setOpen(isOpen);
    }

    const handleDeletePatient = async () => {
        function handleDeletePatientId() {
            dispatch(deleteItemFromData(patientId));
        }

        await handleDelete({
            entity: "patients",
            id: patientId,
            onSuccess: handleDeletePatientId,
            message: "Карту пацієнта успішно видалено",
            isLocalLoading: true,
        });
        dispatch(setPatientId(""));
        dispatch(setIsVisibleModalDialog(false));
    };

    return (
        <div className='container patients_container'>
            <Navigation />
            <PatientsHeader
                handleChange={handleChange}
                query={query}
                toggleDrawer={toggleDrawer}
                handleChangeSortOpton={handleChangeSortOpton}
                sortOption={sortOption}
            />
            <main className='main_content_container'>
                <PatientsList data={data} isLoading={isLoading} />
                <PatientsPagination
                    activepage={activepage}
                    handleChangeActivepage={handleChangeActivepage}
                    limitPage={limitPage}
                />
                <AppointmentsSearchDrayer
                    toggleDrawer={toggleDrawer}
                    open={open}
                    isExistuser={false}
                />
                <ModalDialog
                    onConfirm={handleDeletePatient}
                    title='Видалити карту пацієнта?'
                    message={`Ви впевнені, що хочете видалити карту пацієнта ${
                        patientName ? patientName : ""
                    }?`}
                />
            </main>
        </div>
    );
}
